<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Produtividade — Resumo do fiscal
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como abrir o
        strong  resumo individual
        |  de um fiscal a partir do período Geral e consultar as
        strong  pontuações
        | .

      .toast.toast-primary
        | Exige a permissão
        strong  Produtividade → Resumos → Exibir
        | .

      h5.h5 1. Abrir o resumo
      ol
        li Em
          strong  Produtividade
          | , abra um período na listagem Geral.
        li Na tabela de resumos da equipe, clique na linha do fiscal desejado.

      h5.h5 2. Dados do resumo
      p
        | O cabeçalho mostra o nome do fiscal, a
        strong  referência
        | , o
        strong  valor total
        |  e o botão
        strong  Imprimir
        | .
      p
        | Abaixo ficam os valores de pontuação (bruto, perdidos, líquido,
        |  extraordinário, coletivo, total), dias afastados e flags
        |  (em experiência, encerrado, usuário interno).
      figure.manual-figure
        img(:src="imgShow" alt="Exibição do resumo do fiscal")

      h5.h5 3. Tabela Pontuações
      ol
        li Veja tipo, pontos e observação de cada lançamento.
        li Se houver vínculo, use o link da
          strong  OS-m
          |  ou do
          strong  Documento
          |  para abrir o registro.
        li O botão
          strong  Logs
          |  (se permitido) mostra o histórico da pontuação.

      p
        | As ações de incluir serviços extras, pontos avulso, falta e
        |  afastamentos ficam no manual
        strong  Resumo: Ações
        |  (disponíveis quando o período
        em não
        |  está encerrado).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgShow: require("@/assets/manuais/27-produtividade-resumo-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
